export default __webpack_public_path__ + "static/media/WD_20160903_0284.a49f5fda.JPG";